class SideDrawer extends HTMLElement {
  constructor() {
    super();

    const thisElement = this;

    //Toggle event listeners
    this.addEventListener("drawer-toggle", function () {
      if (this.classList.contains("active")) {
        thisElement.close(this);
      } else {
        thisElement.open(this);
      }
    });

    //Key up and body click events
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.onBodyClick = this.handleBodyClick.bind(this);

    //set drawer height
    this.drawerHeight();

    //add event listener for resize
    window.addEventListener("resize", this.drawerHeight);
  }

  //Open drawer
  open(drawer) {
    this.classList.add("active");
    if (this.classList.contains("drawer--nav")) {
      document.body.classList.add("shadow--body");
      document.body.classList.add("nav-active");
    } else {
      document.body.classList.add("shadow");
    }
    if (document.body.style.position != "fixed") {
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = "fixed";
    }

    this.addEventListener(
      "transitionend",
      () => {
        drawer.focus();
        trapFocus(drawer);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick, {
      passive: true,
    });
    this.updateActiveNav();
  }

  //Close drawer
  close() {
    this.classList.remove("active");

    const activeDrawers = document.querySelectorAll("side-drawer.active");
    if (!activeDrawers.length) {
      if (this.classList.contains("drawer--nav")) {
        document.body.classList.remove("shadow--body");
        document.body.classList.remove("nav-active");
      } else {
        document.body.classList.remove("shadow");
      }
      const scrollY = document.body.style.top;
      document.body.style.top = "";
      document.body.style.position = "";
      window.scrollTo(0, parseInt(scrollY || 0) * -1);
      document.body.removeEventListener("click", this.onBodyClick, {
        passive: true,
      });
    }

    removeTrapFocus(this);
    this.updateActiveNav();
  }

  //Body click event to close drawer
  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this &&
      !target.closest("side-drawer") &&
      !target.closest("side-drawer-toggle")
    ) {
      this.close();
    }
  }

  //recalculate height of drawer when viewport changes
  drawerHeight() {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
  }

  updateActiveNav() {
    const navLinks = document.querySelectorAll(".js-nav-link");
    if (navLinks.length) {
      navLinks.forEach((link) => {
        const linkDrawer = document.getElementById(
          link.getAttribute("data-drawer")
        );
        if (linkDrawer && linkDrawer.classList.contains("active")) {
          link.classList.add("active");
        } else {
          link.classList.remove("active");
        }
      });
    }
  }
}

customElements.define("side-drawer", SideDrawer);
